import { createElement, styled, composedProps } from '@vebox/etui-system';

const SpanElement = createElement('span');
const Span = styled(SpanElement)(composedProps);
Span.displayName = 'Span';

export { Span };
